/**
 * Base Vuex
 */
import * as API from '@/endpoints'
import VueCookie from 'vue-cookie'
import Axios from 'axios'
import Vue from 'vue'
import router from '@/router'
import Store from '@/store'
import { Message, Spin } from 'iview'

export default {
  namespaced: true,
  state: {
    auth: null,
    isAuthenticating: false,
    isFullPageLoader: true,
    isFBAuthenticating: true,
    isConfirming: false,
    isAlertModal: false,
    isFilterModal: false,
    isRefreshTokenLoading: false,
    showInstructionCard: false,
    showDoAction: false,
    showSteps: false,
    showInstallApp: false,
    isOnline: true,
    preview: {},
    vCode: null,
    VCodeMobile: null,
    VCodeVerified: false,
    serviceWorker: null,
    fullPageLoader: false,
    showProfile: {
      show: false,
      user: {}
    }
  },
  mutations: {
    setShowProfileInfo(state, v) {
      Vue.set(state.showProfile, 'user', v)
    },
    setShowProfileModal(state, v) {
      Vue.set(state.showProfile, 'show', v)
    },
    setSW(state, v) {
      Vue.set(state, 'serviceWorker', v)
    },
    setVCodeVerified(state, v) {
      Vue.set(state,'VCodeVerified',v);
    },
    redirectToVerify(state) {
      router.push('/'+router.currentRoute.params.brandSlug+'/verify')
    },
    redirectToRegister(state) {
      router.push('/'+router.currentRoute.params.brandSlug+'/login?type=signup')
    },
    setVCodeMobile(state, v) {
      Vue.set(state,'VCodeMobile',v);
    },
    setVCode(state, v) {
      Vue.set(state,'vCode',v);
      if(state.vCode && router.path !== '/verify')
        router.push('/'+router.currentRoute.params.brandSlug+'/verify')
    },
    setOnlineStatus(state, v) {
      Vue.set(state,'isOnline',v);
    },
    setShowInstallApp(state, v) {
      Vue.set(state,'showInstallApp',v);
    },
    setShowSteps(state, v) {
      Vue.set(state,'showSteps',v);
    },
    showPWAInstallation(state, v) {
      Vue.set(state, 'showInstructionCard', v);
    },
    showDoActionModal(state, v) {
      Vue.set(state, 'showDoAction', v);
    },
    setAlertModal(state, v) {
      Vue.set(state, 'isAlertModal', v);
    },
    setFilterModal(state, v) {
      Vue.set(state, 'isFilterModal', v);
    },
    setConfimationLoader(state, v) {
      Vue.set(state, 'isConfirming', v)
    },
    setPreview (state, v) {
      Vue.set(state, 'preview', v)
    },
    setIsRefreshTokenLoading (state, v) {
      Vue.set(state, 'isRefreshTokenLoading', v)
    },
    setUserAuth (state, v) {
      Vue.set(state, 'auth', {})
      Vue.set(state, 'auth', v)
    },
    setUserAuthLoader (state, v) {
      Vue.set(state, 'isAuthenticating', v)
    },
    setLoadingPage (state, v) {
      if (v) {
        state.fullPageLoader = true;
        Spin.show({
          render: h => {
            return h('div', [
              h('Icon', {
                class: 'm-spin-icon-load',
                props: {
                  type: 'load-c',
                  size: 20
                }
              }),
              h('div', 'Loading')
            ])
          }
        })
      }
      else {
        state.fullPageLoader = false
        Spin.hide()
      }
    }
  },
  getters: {
    loadingUser(state) {
      return state.isAuthenticating;
    },
    fullPageLoader(state) {
      return state.fullPageLoader
    }
  },
  actions: {
    getCode({ commit, dispatch, state}, {text,mobile,vcode}) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.base + '/send/verification/code', {text,mobile}).then(
          res => {
            resolve({code: vcode, data: res.data})
          }, error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          })
      })
    },
    resendEmailConfirmation({ commit, dispatch, state}) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.user + '/email/activate/resend').then(
          res => { resolve(res.data) },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    initiateConfirmation({ commit, dispatch, state}, {key, username}) {
      return new Promise((resolve, reject) => {
        commit('setConfimationLoader', true)
        Axios.get(API.endpoints.user + '/email/activate?key='+ key +'&username=' + username).then(
          res => {
            commit('setConfimationLoader', false)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setConfimationLoader', false)
            reject(error)
          }
        )
      })
    },
    getPrescription ({ commit, dispatch, state}, {code, type, id}) {
      return new Promise((resolve, reject) => {
        if (type === 'group') {
          Axios.get(API.endpoints.prescribe + '/careplan/' + code).then(
            res => {
              commit('setPreview', res.data)
              resolve(res.data)
            },
            error => {
              dispatch('exceptionHandling', { _err: error }, { root: 1 })
              reject(error)
            }
          )
        } else {
          Axios.get(API.endpoints.prescription + '/' + code).then(
            res => {
              commit('setPreview', res.data)
              resolve(res.data)
            },
            error => {
              dispatch('exceptionHandling', { _err: error }, { root: 1 })
              reject(error)
            }
          )
        }
      })
    },
    getPreview ({ commit, dispatch, state}, {id, type}) {
      return new Promise((resolve, reject) => {
        if (type === 'group') {
          Axios.get(API.endpoints.careplan + '/' + id).then(
            res => {
              commit('setPreview', res.data)
              resolve(res.data)
            },
            error => {
              dispatch('exceptionHandling', { _err: error }, { root: 1 })
              reject(error)
            }
          )
        } else {
          Axios.get(API.endpoints.brand + '/' + id).then(
            res => {
              commit('setPreview', res.data)
              resolve(res.data)
            },
            error => {
              dispatch('exceptionHandling', { _err: error }, { root: 1 })
              reject(error)
            }
          )
        }
      })
    },
    signout ({ commit, dispatch, rootState }) {
      return new Promise( (resolve, reject) => {
        if ( VueCookie.get('os_type') === "ios" ) {
          window.webkit.messageHandlers.onNativeCalled.postMessage({
            name: 'authLogout',
            params: {}
          })
          return false;
        }

        commit('setLoadingPage', true)
        Axios.post(API.endpoints.user + '/logout')
          .then( res => {
            commit('setUserAuth', null)
            commit('user/setUserInfo', null, { root: 1 })
            commit('user/resetCurrentUser', null, { root: 1})
            
            Axios.defaults.headers.common['Authorization'] = null
            
            dispatch("guest/registerGuest", null, {root:1});
            dispatch('eventHit', {eventCategory:'signout',eventAction:"delete cookie" +' - signout - ',eventLabel:'delete cookie'})
            
            localStorage.removeItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
            VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_COURSE`);
            VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_ARTICLE`);
            // delete subscription to firebase notification
            if (window.localStorage.getItem("notification_enabled") === "true") {
              window.signout = true
              document.getElementById("PUSHNOTIF").click()
            }
            // dispatch('authenticate', {response: {password: 'Sharp3nGu3st', email: 'guest'}})
            //   .then(res => {
            //     BroadcastEvent.$emit("onSignout");
            //   })
            router.replace({path: '/'+router.currentRoute.params.brandSlug+'/home'})
            commit('setLoadingPage', false)
            resolve(true);
          })
          .catch( error => {
            commit('setLoadingPage', false)
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(false);
          })
      })
    },
    registerByKey({ commit, dispatch, state }, { data }) {
      return new Promise((resolve, reject) => {
        delete Axios.defaults.headers.common["Authorization"];
        Axios.post(API.endpoints.base + '/user/email/owner/activate', data).then(
          res => {
            Axios.defaults.headers.common['Authorization'] = null
            dispatch('authenticate', { response: data, reroute: '/onboarding', isRegister: true })
            resolve(res.data)
          }, error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    register ({ commit, dispatch, state }, { data , reroute}) {
      if(data.user_type === 'anonymous') {
        return new Promise((resolve, reject) => {
          Axios.put(API.endpoints.user + '/guest', data).then(
            res => {
              Axios.defaults.headers.common['Authorization'] = null
              dispatch('authenticate', { response: data, reroute: reroute, isRegister: true })
              resolve(res.data)
            }, error => {
              dispatch('exceptionHandling', { _err: error }, { root: 1 })
              reject(error)
            }
          )
        })
      } else {
        return new Promise((resolve, reject) => {
          delete Axios.defaults.headers.common["Authorization"];
          data.brand_id = Cons[0].BRAND_ID
          Axios.post(API.endpoints.user + '/register', data).then(
            res => {
              if (res.data.error){
                Message.warning({
                  content: res.data.error.message,
                  duration: 5,
                  closable: true
                });
                reject(res)
              }
              else {
                Axios.defaults.headers.common['Authorization'] = null
                resolve(dispatch('authenticate', { response: data, reroute: reroute, isRegister: true }))
              }
            }, error => {
              if (error.response.status == 412) {
                Store.dispatch("user/verification", {email: data.email})
                  .then( res => {
                    router.replace("/verification-message?email=" + data.email);
                    Message.info("Email verification sent.");
                  })
                return false;
              }
              else {
                Message.warning({
                  content: error.response.data.error.message,
                  duration: 5,
                  closable: true
                });
              }
              // dispatch('exceptionHandling', { _err: error }, { root: 1 })
              reject(error)
            }
          )
        })
      }
    },
    getFacebookLink ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.login).then(
          res => {
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    fbAuthenticate ({ commit, dispatch, state}, {code}) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.login + '/redirect?code=' + code).then(
          res => {
            state.isFBAuthenticating = false
            commit('setUserAuth', res.data)

            localStorage.setItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE', JSON.stringify(state.auth))
            let mCookie = localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
            let uCookie = JSON.parse(mCookie)

            Axios.defaults.headers.common['Authorization'] = null
            Axios.defaults.headers.common['Authorization'] = 'Bearer ' + uCookie.access_token

            commit('setUserAuthLoader', false)
            resolve(res.data)
            router.replace({path: '/'+router.currentRoute.params.brandSlug+'/home'})
          },
          error => {
            state.isFBAuthenticating = false
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    acceptPrescriptionCode({commit}, {code}) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.base + '/careplan/'+code+'/accept')
          .then( res => {
            console.info(res.data);
          }, error => {
            // dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          })
      });
    },
    authenticate ({ commit, dispatch, state, rootState }, { response, reroute, isRegister }) {
      return new Promise((resolve, reject) => {
        let uData = null
        if ('authResponse' in response && 'accessToken' in response.autResponse) {
          uData = { fb_token: response.authResponse.accessToken }
        } else {
          uData = {
            username: response.email || response.contact_number || response.username,
            password: response.password,
            token: response.token,
          }
        }

        uData.brand_id = Cons[0].BRAND_ID
        commit('setUserAuthLoader', true)
        commit('setLoadingPage', true)

        Axios.post( process.env.VUE_APP_LOGIN_API, uData )
          .then( res => {

            if ( res.data.refresh_token ) {
              dispatch('refreshToken', {
                refreshToken:res.data.refresh_token,
                forceReload:false
              })
              .then(refreshResponse => {
                if ( reroute ) {
                  setTimeout(() => {

                    if(isRegister)
                      router.replace(`/${router.currentRoute.params.brandSlug}/onboarding`);
                    else
                      router.replace(`/${router.currentRoute.params.brandSlug}/onboarding?skip_user_info_verification=true`);

                  }, 1000);
                } else {
                  setTimeout(() => {
                    router.replace(`/${router.currentRoute.params.brandSlug}/home`);
                  }, 1000);
                }

                commit('setUserAuthLoader', false)
                console.log(refreshResponse)
                resolve(true)
              })
              .catch(refreshError => {
                reject(false);
                commit('setUserAuthLoader', false)
                console.log(refreshError)
              })
            } else {
              localStorage.removeItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
              VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_COURSE`);
              VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_ARTICLE`);
              commit('setUserAuth', res.data)
              localStorage.setItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE', JSON.stringify(res.data))
              let mCookie = localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
              let uCookie = JSON.parse(mCookie)

              Axios.defaults.headers.common['Authorization'] = null
              Axios.defaults.headers.common['Authorization'] = 'Bearer ' + uCookie.access_token

              dispatch('user/getUserInfo', null, {root:1});

              if( VueCookie.get("os_type") === "ios" ) {
                window.webkit.messageHandlers.onNativeCalled.postMessage({
                  name: "makeNativeAuth",
                  params: refreshResponse.data
                });
              }

              commit('setLoadingPage', false)

              if ( reroute ) {
                setTimeout(() => {
                  router.replace(`/${router.currentRoute.params.brandSlug}/onboarding`);
                }, 1000);
              } else {
                setTimeout(() => {
                  router.replace(`/${router.currentRoute.params.brandSlug}/home`);
                }, 1000);
              }

              commit('setUserAuthLoader', false);
              resolve(refreshResponse)
            }

          })
          .catch( error => {
            commit('setUserAuthLoader', false)
            commit('setLoadingPage', false)
            Message.error( { content:_.get(error.response, 'data.error.message', 'Something went wrong, please try again'), duration: 3 });
            console.log(error)
            reject(error);
          });
      })
    },
    refreshToken({ commit, rootstate, dispatch, state},{refreshToken,forceReload}){
        if(state.isRefreshTokenLoading) return;

        if ( router.currentRoute.name == 'Brand Preview' || router.currentRoute.name == 'Preview') {
          console.log("Im in")
          localStorage.removeItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
          VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_COURSE`);
          VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_ARTICLE`);

          localStorage.setItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE', JSON.stringify(state.auth))
          let mCookie = localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
          let uCookie = JSON.parse(mCookie)

          Axios.defaults.headers.common['Authorization'] = null
          Axios.defaults.headers.common['Authorization'] = 'Bearer ' + uCookie.access_token

          dispatch('user/getUserInfo', null, {root:1});
          commit('setLoadingPage', false)
          commit('setUserAuthLoader', false);
          return false;
        }

        commit('setIsRefreshTokenLoading',true)
        return new Promise((resolve,reject)=>{
          Axios.post(API.endpoints.refreshToken, {
            'refresh_token': refreshToken,
            'client_id': 'HqrmdSC4PXaeHjuN',
            'client_secret': '06UC9fZVxYWRFzxwdRIDdTJ990J1Jlqq',
            'grant_type': 'refresh_token'
          }).then(refreshResponse => {
            localStorage.removeItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
            VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_COURSE`);
            VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_ARTICLE`);
            commit('setUserAuth', refreshResponse.data)
            localStorage.setItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE', JSON.stringify(state.auth))
            let mCookie = localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
            let uCookie = JSON.parse(mCookie)

            Axios.defaults.headers.common['Authorization'] = null
            Axios.defaults.headers.common['Authorization'] = 'Bearer ' + uCookie.access_token

            dispatch('user/getUserInfo', null, {root:1});
            commit('setIsRefreshTokenLoading',false)

            if( VueCookie.get("os_type") === "ios" ) {
              window.webkit.messageHandlers.onNativeCalled.postMessage({
                name: "makeNativeAuth",
                params: refreshResponse.data
              });
            }

            if(forceReload) location.reload()

            commit('setLoadingPage', false)
            commit('setUserAuthLoader', false);
            resolve(refreshResponse)
          },refreshError => {
            commit('setLoadingPage', false)            
            commit('setUserAuthLoader', false);
            commit('setIsRefreshTokenLoading',false)
            dispatch("guest/registerGuest", null, {root:1});   
            reject(refreshError)
          })
      })
    },
    getRedirectLink(context, { url }) {
      return new Promise((resolve, reject) => {
        let params = {
          url: encodeURIComponent(url)
        }
        Axios.get(API.endpoints.dynamicLink, { params }).then(res => {
          resolve(res)
        }, err => {
          reject(err)
        })
      })
    },
    async onRegisterUserStory( context, payload ) {
      try {
        let userCurrentUserStory = context.rootGetters["brand/getPackageStories"];

        if( userCurrentUserStory.length > 0 )
          await context.dispatch('user/unfollowGroup', userCurrentUserStory[0].id, {root:1});

        if ( payload.userStory )
          await context.dispatch('user/followGroups', { ids: [payload.userStory] }, {root:1});

        let hasPlan = (payload.userStory) ? true:false
        VueCookie.delete('PRESCRIPTION_GROUP')
        VueCookie.delete('PRESCRIPTION_USER_STORY')

        if( context.rootGetters['user/userInfo'].user_type === 'member' )
          router.replace(`/${payload.slug}/onboarding?skip_user_info_verification=true`);
        else
          router.replace(`/${payload.slug}/home`);

      } catch(e) {
        console.log(e)
      }
    },
    eventHit(state,{eventCategory,eventAction,eventLabel}){
      // ga('send', {
      //   hitType: 'event',
      //   eventCategory: eventCategory,
      //   eventAction: eventAction,
      //   eventLabel: eventLabel
      //   });
    }
  }
}
